import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Button } from 'ustore-ui';

import { I18nPipe } from '../../shared/pipes/i18n.pipe';

type OrderSuccessFlow = 'default' | 'cpcActivation';

@Component({
  selector: 'umkt-order-success',
  standalone: true,
  imports: [CommonModule, RouterModule, Button, I18nPipe],
  templateUrl: './order-success.component.html',
  styleUrls: ['./order-success.component.scss']
})
export class OrderSuccessComponent {
  currentYear = new Date().getFullYear();
  flow: OrderSuccessFlow = 'default';
  email = '';
  private router = inject(Router);

  constructor() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.applyNavigationState(navigation.extras.state);
    } else if (history.state) {
      this.applyNavigationState(history.state);
    }
  }

  get isCpcActivationFlow(): boolean {
    return this.flow === 'cpcActivation';
  }

  get titleKey(): string {
    return this.isCpcActivationFlow
      ? 'pages.orderSuccess.cpcActivation.title'
      : 'pages.orderSuccess.title';
  }

  get message1Key(): string {
    return this.isCpcActivationFlow
      ? 'pages.orderSuccess.cpcActivation.message1'
      : 'pages.orderSuccess.message1';
  }

  get message2Key(): string {
    return this.isCpcActivationFlow
      ? 'pages.orderSuccess.cpcActivation.message2'
      : 'pages.orderSuccess.message2';
  }

  get primaryButtonKey(): string {
    return this.isCpcActivationFlow
      ? 'pages.orderSuccess.cpcActivation.buttonPendingOrders'
      : 'pages.orderSuccess.buttonOrders';
  }

  get secondaryButtonKey(): string {
    return this.isCpcActivationFlow
      ? 'pages.orderSuccess.cpcActivation.buttonOrders'
      : 'pages.orderSuccess.buttonHome';
  }

  goToPrimaryAction(): void {
    if (this.isCpcActivationFlow) {
      this.router.navigate(['/my-account/pending-orders']);
      return;
    }

    this.goToMyOrders();
  }

  goToSecondaryAction(): void {
    if (this.isCpcActivationFlow) {
      this.router.navigate(['/my-account/orders']);
      return;
    }

    this.goToHome();
  }

  goToMyOrders(): void {
    this.router.navigate(['/my-account/orders']);
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }

  private applyNavigationState(state: Record<string, unknown>): void {
    if (state['flow'] === 'cpcActivation') {
      this.flow = 'cpcActivation';
    }

    if (typeof state['email'] === 'string') {
      this.email = state['email'];
    }
  }
}
